import { Component, OnInit, OnDestroy } from "@angular/core";
import { MuestraService } from '../../servicios/muestra-servicios';
import { LogService } from "../../servicios/log-servicios";
import { take, takeUntil } from "rxjs/operators";
import { Subject, Subscription } from "rxjs";
import { CoordCampo } from '../../interfaces/varias-interfaces';


@Component({
  selector: 'app-selectbox-elem',
  templateUrl: './selectbox-elem.component.html',
  styleUrls: ['./selectbox-elem.component.css']
})
export class SelectboxElemComponent implements OnInit, OnDestroy {
  private _onDestroy$: Subject<void> = new Subject();

  muestraSelectboxSub: Subscription;
  muestraSelectbox: boolean = false;
  sbTitulo: string = '';
  sbTexto1: string = '';
  sbTexto2: string = '';
  sbBotones: string = '';
  sbIcono: string = '';
  sbRespuesta: string = '';
  sbMostrarSiHaySoloUnaOpcion: boolean = true;
  sbMostrarAceptarCancelar: boolean = true;

  vfAceptar: boolean = false;
  vfCancelar: boolean = false;
  vfSi: boolean = false;
  vfNo: boolean = false;
  vfSalir: boolean = false;
  cantBotones: number = 0;
  lineaBotonesStyle: object;
  botonStyle: object;
  aceptarStyle: object;
  invisibleStyle: object;
  aceptarEnabled: boolean = false;
  selectOpciones: string[];
  filtroTxtSelect: string;
  verBotones: boolean = false;
  respuestaCombo: string = '';

  constructor(
    private muestraService: MuestraService,
    private logService: LogService
  ) { }

  emitirRespuesta(boton: string) {
    if (boton == 'Aceptar') {
      if (this.respuestaCombo != '') {
        this.muestraService.ocultaSelectbox(this.respuestaCombo);
      }
    } else {
      this.muestraService.ocultaSelectbox('Cancelar');
    }
  }

  public abrirCombo(campo: string) {
    this.verBotones = false;
    this.logService.consoleLog('2', 'CE SelectBox servicio muestraCombo Cli Opc: ' + this.selectOpciones[1]);

    const campoBase: HTMLInputElement = <HTMLInputElement>document.getElementById(campo);
    this.muestraService.disableScroll();    //antes de leer las coordenadas porque al desaparecer el scroll cambia el width del campo.
    const campoBaseRect = campoBase.getBoundingClientRect();
    const datosCampo: CoordCampo = {
      left: campoBaseRect.left + 'px',
      top: campoBaseRect.top + 'px',
      width: campoBaseRect.width + 'px',
      height: campoBaseRect.height + 'px'
    };
    const campoBaseClass = campoBase.className;
    const opcionesCombo: string[] = this.selectOpciones;

    this.muestraService.muestraCombo(campoBase.value, opcionesCombo, false, datosCampo, campoBaseClass, 'N', 'N')
      .pipe(take(1))
      .subscribe(r => {
        this.verBotones = true;
        this.logService.consoleLog('2', 'CE SelectBox Respuesta: ' + r);
        if (r != 'Combo cerrado con Esc o clic afuera') {
          //esto no sería necesario, gracias a las interpolaciones como {{filtroUsrCliente}}
          //campoBase.setAttribute('value', r);
          this.filtroTxtSelect = r;
          this.aceptarStyle = { width: '50%', margin: '5px' };
          this.aceptarEnabled = true;
          this.respuestaCombo = r;
          if(!this.sbMostrarAceptarCancelar){
            this.emitirRespuesta('Aceptar');
          }
        }
        this.muestraService.enableScroll();
      });
  }

  ngOnInit() {
    this.logService.consoleLog('2', 'CE SelectBox init');
    this.muestraSelectboxSub = this.muestraService.selectbox$
      .pipe(takeUntil(this._onDestroy$))
      .subscribe(p => {
        this.muestraSelectbox = p;
        if (this.muestraSelectbox) {
          //leo los paráms para mostrar en el html
          this.logService.consoleLog('2', 'CE SelectBox mSb true');
          this.sbTitulo = this.muestraService.sbTitulo;
          this.selectOpciones = this.muestraService.sbArrOpc;
          this.sbRespuesta = '';
          this.sbMostrarSiHaySoloUnaOpcion = this.muestraService.sbMostrarSiHaySoloUnaOpcion;
          this.sbMostrarAceptarCancelar = this.muestraService.sbMostrarAceptarCancelar;
          this.lineaBotonesStyle = { padding: '2px 10px' };
          this.botonStyle = { width: '50%', margin: '5px' };
          this.aceptarStyle = { width: '50%', margin: '5px', color: '#444444', "background-color": '#AAAAAA' };
          this.invisibleStyle = { width: '50%', margin: '5px', color: 'white', "background-color": 'white' }
          this.aceptarEnabled = false;
          //para que abra combo apenas entra al selectbox, pero con mínima demora para q dibuje campo de input txtSelect
          setTimeout(() => {
            this.logService.consoleLog('2', 'CE SelectBox mSb demora');
            this.abrirCombo('txtSelect')
          })
        } else {
          //nada
          this.logService.consoleLog('2', 'CE SelectBox mSb false');
        }
      })
  }

  ngOnDestroy() {
    //Esta técnica de this._onDestroy$ en ngOnDestroy
    //permite liberar todos los Observables que tengan un .takeUntil(this._onDestroy$)
    //Si un Observable tiene take(n) no requiere destruirse porque ya lo hace luego de leer n veces
    this.logService.consoleLog('2', 'CE SelectBox cerrando selectbox-elem.component');
    this._onDestroy$.next();
    this._onDestroy$.complete();
  }
}
